export function getFirstStringOrDefault(
  strings: string[] | string | undefined,
  defaultValue: string,
): string {
  switch (typeof strings) {
    case 'object':
      return strings[0];
    case 'string':
      return strings;
    default:
      return defaultValue;
  }
}
